module.exports = __webpack_public_path__ + "img/symbol_1.7d069eac.png";